import { applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

let sagaDebugMonitor = {};
let is_browser = process.browser == true || process.browser == undefined;

if (is_browser) {
  //   client-side-only code
  const monitor = window['__SAGA_MONITOR_EXTENSION__'];
  sagaDebugMonitor.sagaMonitor = monitor;
}

const sagaMiddleware = createSagaMiddleware();
const defaultMiddlewares = [sagaMiddleware];
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

export function runSagas(rootSagas) {
  return sagaMiddleware.run(rootSagas);
}

export default composeEnhancers(applyMiddleware(...defaultMiddlewares));
